import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../../../store";
import { downloadFile } from "../modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    responseDetails: state.insuranceRequestDetailsReducer.responseDetails,
    requestDetails: state.insuranceRequestDetailsReducer.requestDetails,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators(
    {
      downloadFile,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
